import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  FormDashboardTextarea as Textarea,
  FormRow,
  SaveButton
} from '../../../components'
import { Icon } from '@fluentui/react/lib/Icon';

const Link = () => <Icon iconName="Link" className="ms-Link text-xl" />;
const OpenFile = () => <Icon iconName="OpenFile" className="ms-OpenFile text-xl" />;

const Form = () => {
  return (
    <form>
      <FormRow>
        <Label>To:</Label>
        <Input className="w-full" defaultValue=""/>
      </FormRow>
      <FormRow>
        <Label>Subject:</Label>
        <Input className="w-full" defaultValue=""/>
      </FormRow>
      <FormRow>
        <Label>Message:</Label>
        <Textarea className="w-full" defaultValue=""/>
      </FormRow>
      <FormRow>
        <div className="flex flex-wrap justify-between items-center">
          <div className="flex items-center mb-8 md:mb-0">
            <div className="flex items-center cursor-pointer text-primary mr-4 lg:mr-8">
              <OpenFile />
              <div className="underline pl-2">Attach File</div>
            </div>
            <div className="flex items-center cursor-pointer text-primary">
              <Link />
              <div className="underline pl-2">Add Internal Link</div>
            </div>
          </div>
          <div className="w-full md:w-auto">
            <SaveButton saveText="Send"/>
          </div>
        </div>
      </FormRow>
    </form>
  )
}

export { Form }
